import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Plus } from 'lucide-react';
import { haccpApi, erroreHaccp } from '../../haccpApi';

// Mansione senza DPI nel DVR: li scrive il responsabile, uno per riga, e valgono per tutti con quella mansione
export const DpiManuali = ({ mansione, iniziali, testid, onSalvato }) => {
  const [aperto, setAperto] = useState(false);
  const [testo, setTesto] = useState('');
  const [busy, setBusy] = useState(false);
  const voci = testo.split('\n').map((s) => s.trim()).filter((s) => s.length >= 2);
  const apri = () => { setTesto((iniziali || []).map((d) => d.nome).join('\n')); setAperto(true); };
  const salva = async () => {
    setBusy(true);
    try {
      await haccpApi.put('/documenti/dpi/manuali', { mansione, dpi: voci.map((nome) => ({ nome })) });
      toast.success(`DPI salvati per la mansione ${mansione.toLowerCase()}`);
      setAperto(false);
      onSalvato();
    } catch (e) { toast.error(erroreHaccp(e, 'DPI non salvati')); } finally { setBusy(false); }
  };
  if (!aperto) {
    return (
      <button onClick={apri} className="text-xs font-semibold text-orange-700 flex items-center gap-1" data-testid={`${testid}-aggiungi-dpi`}>
        <Plus className="h-3.5 w-3.5" />{iniziali?.length ? 'Cambia i DPI scritti da te' : 'Aggiungi i DPI'}
      </button>
    );
  }
  return (
    <div className="w-full space-y-2" data-testid={`${testid}-dpi-form`}>
      <textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={4} placeholder={'Scarpe antiscivolo\nGuanti in nitrile'}
        className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm text-gray-900" style={{ background: '#fff' }} data-testid={`${testid}-dpi-testo`} />
      <p className="text-[11px] text-gray-500">Uno per riga. Valgono per tutti con la mansione {mansione.toLowerCase()}.</p>
      <div className="flex gap-2">
        <button onClick={salva} disabled={busy || !voci.length} className="h-9 px-4 rounded-lg bg-orange-600 text-white text-xs font-semibold flex items-center gap-1 disabled:opacity-60" data-testid={`${testid}-dpi-salva`}>
          {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Salva {voci.length || ''} DPI
        </button>
        <button onClick={() => setAperto(false)} className="h-9 px-3 rounded-lg border border-gray-300 text-xs text-gray-700" data-testid={`${testid}-dpi-annulla`}>Annulla</button>
      </div>
    </div>
  );
};
